import React from "react";
import '../styling/Intro.css';
import { Link } from 'react-scroll';

const Intro = () => {
  

  return (
    <div id="intro-section" className="intro">
      <div className="intro_content">
        <h5>Innovative Solution</h5>
        <h1>Ahmad Attwi</h1>
        <p>Software Development | Tech Support | IT Services</p>
       
        <Link
              to="about-section"
              smooth={window.innerWidth >= 768}
              duration={1000} 
             
            >
               <button className="scroll_button" >
          Scroll Down ↓
        </button>
            </Link>
      </div>
      <ul className="intro-social">
       
        <li>
  <a
    href="https://www.linkedin.com/in/ahmad-attwi-286408243/"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit my LinkedIn"
  >
    <i className="fab fa-linkedin" style={{ fontSize: "30px" }}></i>
  </a>
</li>

     
     <li>
  <a
    href="https://github.com/ahma20d"
    target="_blank"
    rel="noopener noreferrer"
    title="Visit my GitHub"
  >
    <i className="fab fa-github" style={{ fontSize: "30px" }}></i>
  </a>
</li>


<li>
  <a
    href="https://wa.me/9647775039259"
    target="_blank"
    rel="noopener noreferrer"
    title="Chat with me on WhatsApp"
  >
    <i className="fab fa-whatsapp" style={{ fontSize: "30px" }}></i>
  </a>
</li>

<li>
  <a
    href="mailto:ahmadattwi753@gmail.com"
    title="Send me an email"
  >
    <i className="fas fa-envelope" style={{ fontSize: "30px" }}></i>
  </a>
</li>


     
      </ul>
    </div>
  );
};

export default Intro;
